/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { StateModel } from '../models/state-model';

@Injectable({
  providedIn: 'root',
})
export class StateService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiStateGet
   */
  static readonly ApiStateGetPath = '/api/State';

  /**
   * Get the users state cache (all key/value pairs).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStateGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStateGet$Json$Response(params?: {

  }): Observable<StrictHttpResponse<Array<StateModel>>> {

    const rb = new RequestBuilder(this.rootUrl, StateService.ApiStateGetPath, 'get');
    if (params) {


    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<StateModel>>;
      })
    );
  }

  /**
   * Get the users state cache (all key/value pairs).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiStateGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStateGet$Json(params?: {

  }): Observable<Array<StateModel>> {

    return this.apiStateGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<StateModel>>) => r.body as Array<StateModel>)
    );
  }

  /**
   * Path part for operation apiStateKeyGet
   */
  static readonly ApiStateKeyGetPath = '/api/State/{key}';

  /**
   * Get a specific key value.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStateKeyGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStateKeyGet$Json$Response(params: {
    key: null | string;

  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, StateService.ApiStateKeyGetPath, 'get');
    if (params) {

      rb.path('key', params.key, {});

    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Get a specific key value.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiStateKeyGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStateKeyGet$Json(params: {
    key: null | string;

  }): Observable<string> {

    return this.apiStateKeyGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation apiStateKeyValuePost
   */
  static readonly ApiStateKeyValuePostPath = '/api/State/{key}/{value}';

  /**
   * Create or update a key/value pair.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStateKeyValuePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStateKeyValuePost$Response(params: {
    key: null | string;
    value: null | string;

  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, StateService.ApiStateKeyValuePostPath, 'post');
    if (params) {

      rb.path('key', params.key, {});
      rb.path('value', params.value, {});

    }
    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Create or update a key/value pair.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiStateKeyValuePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStateKeyValuePost(params: {
    key: null | string;
    value: null | string;

  }): Observable<void> {

    return this.apiStateKeyValuePost$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiStateDualKeyValueKey2Value2Post
   */
  static readonly ApiStateDualKeyValueKey2Value2PostPath = '/api/State/dual/{key}/{value}/{key2}/{value2}';

  /**
   * Create or update a pair of key/value pairs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStateDualKeyValueKey2Value2Post()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStateDualKeyValueKey2Value2Post$Response(params: {
    key: null | string;
    value: null | string;
    key2: null | string;
    value2: null | string;

  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, StateService.ApiStateDualKeyValueKey2Value2PostPath, 'post');
    if (params) {

      rb.path('key', params.key, {});
      rb.path('value', params.value, {});
      rb.path('key2', params.key2, {});
      rb.path('value2', params.value2, {});

    }
    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Create or update a pair of key/value pairs.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiStateDualKeyValueKey2Value2Post$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStateDualKeyValueKey2Value2Post(params: {
    key: null | string;
    value: null | string;
    key2: null | string;
    value2: null | string;

  }): Observable<void> {

    return this.apiStateDualKeyValueKey2Value2Post$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
